import type { Patient, Reference, Resource } from '@medplum/fhirtypes'
import { createReference } from '@seen/core/references'
import { type FhirValue, isOfType } from '@seen/core/utils'
import { useResource } from '#src/hooks/useResource.ts'

export function useRelatedParticipantReference(
  reference: FhirValue | null | undefined
): Reference<Patient> | undefined {
  const { data: resource } = useResource(reference ?? undefined)
  return getRelatedParticipantReference(resource)
}

export function getRelatedParticipantReference(
  resource: Resource | undefined
): Reference<Patient> | undefined {
  if (!resource) {
    return undefined
  }

  if (isOfType(resource, 'Patient')) {
    return createReference(resource)
  }

  const subjectBearing = resource as Resource & {
    subject?: Reference
    patient?: Reference
  }

  const subject = subjectBearing.subject
  if (isOfType(subject, 'Patient')) {
    return subject
  }

  const patient = subjectBearing.patient
  if (isOfType(patient, 'Patient')) {
    return patient
  }

  if (isOfType(resource, 'Appointment')) {
    const actor = resource.participant?.find((p) =>
      isOfType(p.actor, 'Patient')
    )?.actor
    if (isOfType(actor, 'Patient')) {
      return actor
    }
  }

  return undefined
}
